export default __webpack_public_path__ + "static/media/arduino.359e2621.png";